<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Create Sales Quotation</h4>
                <p class="text-subtitle-1">Sales Quotation Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <QuotationForm
                    v-model="data"
                    ref="form"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleSubmit" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    Save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleCancel">
                    Cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
</template>

<script>
import PAlert from "./../../components/common/PAlert.vue"
import QuotationForm from './../../components/Sales/QuotationForm.vue'
import { mapActions } from 'vuex'
export default {    
    name: "QuotationCreateView",
    components: {
        QuotationForm,
        PAlert
    },
    data() {
        return {
            data: null,
            idempotentKey: null,
             alert: {
                title: "",
                content: "",
                callback: null
            },
            loading: false
        }
    },
    methods: {
        ...mapActions("sales/dpk", ["fetchDpk"]),
        ...mapActions("sales/quotation", ["storeQuotation"]),
        ...mapActions({
            snackbar: "ui/snackbar/show"
        }),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.idempotentKey = dpk.key;
        },
        handleSubmit() {
            this.alert = { content: "Are you sure you want to save?", value: true, callback: this.submit}
        },
        async submit() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            await this.storeQuotation({...this.data, dpk: this.idempotentKey})
                .then((response) => {
                    this.snackbar({color: "success", text: "Quotation Create Success"});
                    this.$router.replace({
                        name: "QuotationDisplay",
                        params: {
                            id: response.data.id
                        }
                    })
                })
                .catch((error) => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar({color: "error", text: message});
                }).finally(() => {
                    this.loading = false;
                })
        },
        handleCancel() {
            this.alert = { content: "Are you sure you want to cancel?", value: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back()
        }
        
    },
    mounted() {
        this.$refs.form.addLine()

    },
    created() {
        this.getDpkData();
    }
}
</script>

<style>

</style>